export { default } from 'Components/ProductCard/ProductCard'
